import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { CommonSubscriptionCrumbs } from './breadcrumb';

export const AnscNotificationsSubscriptionCrumbs = [
  ...CommonSubscriptionCrumbs,
  {
    name: 'Notifiche da ANSC',
    path: '/iscrizioni/notifiche/ansc',
  },
];

export const DetailAnscNotificationsSubscriptionCrumbs = [
  ...AnscNotificationsSubscriptionCrumbs,
  {
    name: 'Dettaglio Notifiche da ANSC',
    path: '/iscrizioni/notifiche/ansc/visualizza/:id/:idNotifica',
  },
];

export const EditAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = '/iscrizioni/notifiche/ansc/modifica/:id/:idNotifica'
): Array<BreadcrumbItem> => {
  return [
    ...AnscNotificationsSubscriptionCrumbs,
    {
      name: 'Modifica Notifiche da ANSC',
      path: goBackUrl,
    },
  ];
};

export const BirthAnscNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl = '/iscrizioni/notifiche/ansc/modifica/:id/:idNotifica'
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const CivilUnionAnscNotificationsResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailAnscNotificationsResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionAnscNotificationsResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionAnscNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailAnscNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionAnscNotificationsNonResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const MarriageAnscNotificationsResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailAnscNotificationsResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...MarriageAnscNotificationsResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageAnscNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailAnscNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...MarriageAnscNotificationsNonResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const DeathAnscNotificationsResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationAnscNotificationsResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...DeathAnscNotificationsResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathAnscNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationAnscNotificationsNonResidentSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...DeathAnscNotificationsNonResidentSubscriptionCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const FamilyAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyMotherDetailAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyFatherDetailAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/iscrizioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const CohabitationAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailAnscNotificationsSubscriptionCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CohabitationAnscNotificationsSubscriptionCrumbs(goBackUrl),
    {
      name: 'Nascita Convivenza',
      path: '/iscrizioni/notifiche/ansc/modifica/:id/:idNotifica/convivenza/nascita',
    },
  ];
};
